import { useState, useEffect, useCallback } from 'react';

import DateAndTime from '../DateAndTime/DateAndTime';
import SubmitForm from '../SubmitForm/SubmitForm';

import './Main.css';

const Main = ({ data, bookDone, courseClass }) => {
  const [sections, setSections] = useState({
    section1: true,
    section2: false,
    section3: false,
  });
  const [added, setAdded] = useState(false);
  const [firstLoad, setFirstLoad] = useState(true);
  const [firstLoadForm, setFirstLoadForm] = useState(true);
  const [dataSelected, setDataSelected] = useState({});

  const addData = useCallback((name, service_id) => {
    if (name) {
      setDataSelected((prev) => {
        const { date, ...rest } = prev;
        return {
          ...rest,
          serviciu: { name, service_id },
        };
      });
      setSections({ section1: false, section2: true, section3: false });
      setFirstLoad(false);
    }
  }, []);

  useEffect(() => {
    const servicesData = data.services;
    if (courseClass) {
      if (courseClass === 'level') {
        addData(servicesData[0].name, servicesData[0].id);
      } else if (courseClass === 'renewal') {
        addData(servicesData[1].name, servicesData[1].id);
      } else if (courseClass === 'traffic') {
        addData(servicesData[2].name, servicesData[2].id);
      }
    }
  }, [courseClass, data.services, addData]);

  const changeScreen = () => {
    setAdded(true);
  };

  const handleSection3 = (date) => {
    setFirstLoadForm(false);
    setDataSelected({ ...dataSelected, date });
    setSections({ section1: false, section2: false, section3: true });
  };

  if (added) {
    return (
      <div className="text-center">
        <hr />
        <h1>Te-ai programat cu succes!</h1>
        <p>Data ora etc...</p>
        <p>Ai primit un email cu toate detaliile, o zi buna!</p>
      </div>
    );
  }

  const renderSectionItem = (
    sectionKey,
    content,
    onClick,
    clickable = true
  ) => {
    let extraClass = '';
    if (sectionKey === 'section2') {
      extraClass = firstLoad ? '' : 'hover-effect';
    } else if (sectionKey === 'section3') {
      extraClass = firstLoadForm ? '' : 'hover-effect';
    } else {
      extraClass = 'hover-effect';
    }
    const isActive = sections[sectionKey];
    const className = `service ${
      !isActive ? extraClass : 'hover-effect active'
    }`;

    return (
      <>
        <div onClick={() => clickable && onClick()} className={className}>
          <div>{content}</div>
          <div>
            <i className="fas fa-chevron-right"></i>
          </div>
        </div>
        <hr />
      </>
    );
  };

  const renderLeftNavigation = () => (
    <div className="left-side">
      {renderSectionItem(
        'section1',
        <>
          <i className="fas fa-briefcase me-2"></i>
          {dataSelected.serviciu ? (
            <>{dataSelected.serviciu.name}</>
          ) : (
            'Service'
          )}
        </>,
        () => setSections({ section1: true, section2: false, section3: false })
      )}
      {renderSectionItem(
        'section2',
        <>
          <i className="far fa-calendar-alt me-2"></i> Date &amp; Time{' '}
          <p>
            {dataSelected.date &&
              `${dataSelected.date.split(',')[0]} ${dataSelected.date
                .split(',')[1]
                .trim()}`}
          </p>
        </>,
        () => {
          if (!firstLoad)
            setSections({ section1: false, section2: true, section3: false });
        },
        !firstLoad
      )}
      {renderSectionItem(
        'section3',
        <>
          <i className="far fa-user me-2"></i> Your information
        </>,
        () => {
          if (dataSelected.date) {
            setSections({ section1: false, section2: false, section3: true });
          }
        },
        !!dataSelected.date
      )}
    </div>
  );

  const renderServices = () =>
    data.services.map((el) => (
      <div key={el.name}>
        <div className="service-right" onClick={() => addData(el.name, el.id)}>
          <div className="service-name px-2">
            <div>
              <img
                src="https://static.wixstatic.com/media/3c693a_b0ba4421b9614776a4f3e614985e907c~mv2.jpg/v1/fill/w_383,h_202,al_c,q_80,usm_0.66_1.00_0.01,enc_avif,quality_auto/IMG_7724_JPG.jpg"
                alt="Service"
                style={{ maxWidth: '70px', maxHeight: '70px' }}
                className="me-3"
              />
            </div>
            <h6 className="text-custom-primary">{el.name}</h6>
          </div>
          <div className="service-duration mr-4">
            {el.name === dataSelected?.serviciu?.name && (
              <i className="fas fa-check-circle px-2"></i>
            )}
          </div>
        </div>
        <hr />
      </div>
    ));

  return (
    <div className="container-main">
      {renderLeftNavigation()}
      <div className="vl"></div>
      <div className="right-side">
        {sections.section1 && renderServices()}

        {sections.section2 && (
          <DateAndTime
            changeData={handleSection3}
            sections={sections}
            dataSelected={dataSelected}
          />
        )}

        {sections.section3 && (
          <SubmitForm
            changeScreen={changeScreen}
            data={dataSelected}
            bookDone={bookDone}
          />
        )}
      </div>
    </div>
  );
};

export default Main;
